import { render } from "./product-variants.vue?vue&type=template&id=aadf8d9c"
import script from "./product-variants.vue?vue&type=script&lang=js"
export * from "./product-variants.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__